import { generatePath } from 'react-router-dom'
import { ORGANIC_CAMPAIGNS_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Calendar1, Layers5 } from 'blaze-ui/icons/24'
import { Calendar2 } from 'blaze-ui/icons'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuOrganicCampaignsItem = ({ workspaceId, onPress }: Props) => {
  const to = generatePath(ORGANIC_CAMPAIGNS_PATH, { workspaceId })

  return <NavMenuItem icon={Calendar1} activeIcon={Calendar1} to={to} onPress={onPress} label="Organic Campaigns" />
}

export { NavMenuOrganicCampaignsItem }
